import { Check } from "@mui/icons-material";
import { Step, StepConnector, stepConnectorClasses, StepIconProps, StepLabel, Stepper, styled } from "@mui/material";

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: 'calc(-50% + 16px)',
    right: 'calc(50% + 16px)',
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#0d6efd',
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: '#0d6efd',
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor: '#6c757d',
    borderTopWidth: 3,
    borderRadius: 1,
    ...theme.applyStyles('dark', {
      borderColor: theme.palette.grey[800],
    }),
  },
}));

const QontoStepIconRoot = styled('div')<{ ownerState: { active?: boolean } }>(
  ({ theme }) => ({
    color: '#6c757d',
    display: 'flex',
    height: 22,
    alignItems: 'center',
    '& .QontoStepIcon-completedIcon': {
      color: '#0d6efd',
      zIndex: 1,
      width: 40,
      height: 40,
      borderRadius: '30px',
      backgroundColor: '#fff',
      border: '3px solid #0d6efd',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 600,
      fontSize: 24,
    },
    '& .QontoStepIcon-circle': {
      width: 40,
      height: 40,
      zIndex: 999,
      borderRadius: '30px',
      backgroundColor: '#fff',
      border: '3px solid',
      borderColor: 'currentColor',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontWeight: 600,
      fontSize: 24,
    },
    ...theme.applyStyles('dark', {
      color: "#6c757d",
    }),
    variants: [
      {
        props: ({ ownerState }) => ownerState.active,
        style: {
          color: '#0d6efd',
        },
      },
    ],
  }),
);

function QontoStepIcon(props: StepIconProps) {
  const { active, completed, className, icon } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <div className="QontoStepIcon-completedIcon">
          <Check />
        </div>
      ) : (
        <div className="QontoStepIcon-circle">{icon}</div>
      )}
    </QontoStepIconRoot>
  );
}
const TrialStepper = (props: { stepperInfo: {activeStep: number}}) => {
  const { stepperInfo } = props;
  const steps = [
    'Select Plan',
    'User Info',
    'Payment Info',
    'Finish Account Set-Up',
  ];
  return (
  <Stepper
    activeStep={stepperInfo.activeStep} alternativeLabel connector={<QontoConnector />}
    className="trial-stepper"
  >
      {steps.map((label) => (
        <Step key={label}>
          <StepLabel StepIconComponent={QontoStepIcon}>{label}</StepLabel>
        </Step>
      ))}
    </Stepper>
  );
}

export default TrialStepper;
